import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-covid-self-assessment',
  templateUrl: './covid-self-assessment.component.html',
  styleUrls: ['./covid-self-assessment.component.scss']
})
export class CovidSelfAssessmentComponent implements OnInit {


  step1Result: boolean;

  step2 = false;
  step3 = false;
  step4 = false;
  step5 = false;
  step6 = false;
  step7 = false;

  constructor() { }

  ngOnInit() {

  }

  getstep1Result(value) {
    this.step1Result = value;
    console.log(this.step1Result);

  }

}
